import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icon from '../Icon';
import CommitStatus from './CommitStatus';
import IssueCounter from '../IssueCounter';
import i18n from '../../locales/index';
export default class CommitStatusTimedOut extends CommitStatus {
    renderCounter(issuesCount, issuesDiff) {
        const t = i18n.t;
        return _jsxs("span", { children: [issuesCount > 0 && _jsx(IssueCounter, { issuesCount: issuesCount, issuesDiff: issuesDiff, showDiff: false }), _jsx(Icon, { name: "exclamation", className: "text-danger float-right ml-2", title: t('someAnalyseTimedOut') })] });
    }
}
